module.exports = __webpack_public_path__ + "media/images/users_voice009-202396ac20d817f0c3d4c6024188d6d4.jpg";